"use client";

import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import Button from "../commons/Button";

export default function DialogDeclinedReason({
  open,
  onClose,
  listingTitle,
  declinedReason,
}) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-[99999]">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-[#000] backdrop-blur-sm bg-opacity-75 transition-opacity"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden product-ask-section border-style-decoration bg-[#141414] backdrop-blur-sm shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in w-full max-w-[604px]"
          >
            <div className="w-full relative">
              <button
                onClick={onClose}
                className="absolute top-2 right-2 cursor-pointer z-[1]"
              >
                <img
                  src="/assets/icons/icon-close.svg"
                  alt="Close"
                  className="invert cursor-pointer"
                />
              </button>
              <div className="p-5 py-8 w-full flex flex-col items-center">
                {/* Warning Icon */}
                <img
                  src="/assets/icons/icon-warning-circle.svg"
                  alt="Declined"
                  className="w-[80px] h-[80px] text-red-500"
                />
                
                <div className="flex flex-col items-center mt-6">
                  <span className="text-[28px] lg:text-[36px] text-white text-center">
                    Listing Declined
                  </span>
                  
                  {listingTitle && (
                    <span className="text-sm text-white/80 mt-2 text-center">
                      "{listingTitle}"
                    </span>
                  )}
                </div>

                <div className="w-full mt-6">
                  <div className="bg-[#2A2A2A] border border-red-500/30 rounded-lg p-4">
                    <h4 className="text-white font-medium mb-2">Reason for Decline:</h4>
                    <p className="text-white/80 text-sm leading-relaxed whitespace-pre-wrap">
                      {declinedReason}
                    </p>
                  </div>
                </div>

                <Button
                  onClick={onClose}
                  isActive
                  divClassName="w-full mt-8 max-w-[90%] border-style-decoration-container"
                  buttonClassName="border-style-decoration"
                >
                  Close
                </Button>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
} 